// ------- money format function -------          
function formatMoney(cents, format) {
  if (typeof cents === "string") cents = cents.replace(".", "");
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || "${{amount}}";

  const number = (cents / 100).toFixed(2);
  value = number.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");

  return formatString.replace(placeholderRegex, value);
}

// --- custom Add to cart function  ----
document.addEventListener("click", function (e) {
  const btn = e.target.closest(".quick-add-size-btn");
  if (!btn) return;

  const variantId = btn.getAttribute("data-variant");
  if (!variantId) return;

  // Identify the Product Card (Desktop) vs. the Popup (Mobile)
  const isMobilePopup = btn.closest("#quickAddMobileContainer");
  const product_card = e.target.closest(".product-card-wrapper");

  // Find loader: if in popup, we might not have a card loader, so handle gracefully
  let loaderEl = null;
  if (isMobilePopup) {
    loaderEl = isMobilePopup.querySelector(".product-card__spinner");
  } else {
    loaderEl = product_card.querySelector(".product-card__spinner");
  }

  if (loaderEl) loaderEl.classList.remove("hidden");

  const formData = {
    id: variantId,
    quantity: 1,
    sections: "cart-drawer,cart-icon-bubble",
  };

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      const cartDrawer = document.querySelector("cart-drawer");

      if (cartDrawer) {
        if (cartDrawer.classList.contains("is-empty")) {
          cartDrawer.classList.remove("is-empty");
        }
        // 1. Dawn's built-in function to swap HTML and update the cart
        cartDrawer.renderContents(data);
        // 2. Open the drawer visually
        cartDrawer.open();
      }

      setTimeout(() => {
        loaderEl.classList.add("hidden");
        if (isMobilePopup) {
          document
            .getElementById("quickAddMobileContainer")
            .classList.remove("is-active");
        }
      }, 100);
    })
    .catch((error) => {
      console.error("Error adding to cart:", error);
      loaderEl.classList.add("hidden");
    });
});

// ------- function to update color product content on swatch click in product card -----------
document.addEventListener("click", function (e) {
  const swatch = e.target.closest(".color-swatch-item");
  if (!swatch) return;

  const card = swatch.closest(".card-wrapper");
  const groupBox = card.querySelector(".group-swatches");
  const productId = swatch.getAttribute("card-product-id");
  const products = JSON.parse(
    document.getElementById(`GroupProducts-${productId}`).textContent,
  );

  const selectedProduct = products.find(
    (p) => p.id == swatch.dataset.productId,
  );

  // Update Card URL
  const linkEls = card.querySelectorAll("a");
  linkEls.forEach((a) => (a.href = selectedProduct.url));

  // Update Title
  const titleEl = card.querySelector(".card__heading-text");
  if (titleEl) titleEl.innerText = selectedProduct.title;

  // Update Color
  const colorEl = card.querySelector(".product-color-name");
  if (colorEl) colorEl.innerText = selectedProduct.color;

  // Update Price
  const priceEl = card.querySelector(".price-item");
  if (priceEl) priceEl.innerText = selectedProduct.price;

  // Select the media container
  const mediaContainer = card.querySelector(".card__media .media");

  if (mediaContainer) {
    const images = mediaContainer.querySelectorAll("img");
    // Update Main Image
    if (images[0] && selectedProduct.main_image) {
      images[0].src = selectedProduct.main_image;
      images[0].srcset = selectedProduct.main_image; // Clears srcset so the new src takes priority
    }
    // Update Second Image
    if (images[1] && selectedProduct.second_image) {
      images[1].src = selectedProduct.second_image;
      images[1].srcset = selectedProduct.second_image;
    }
  }

  // Update Sizes
  const sizeContainer = card.querySelector(".quick-add-sizes");
  if (sizeContainer) {
    sizeContainer.innerHTML = "";

    selectedProduct.variants.forEach((v) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "quick-add-size-btn";
      btn.setAttribute("data-variant", v.id);
      btn.textContent = v.variant_title;

      if (!v.available) {
        btn.disabled = true;
        btn.classList.add("disabled");
      }

      sizeContainer.appendChild(btn);
    });
  }
  // Active swatch style
  card
    .querySelectorAll(".color-swatch-item")
    .forEach((s) => s.classList.remove("active"));
  swatch.classList.add("active");
});

// ------ function to update swatch number on product card --------
function updateSwatchesNumber() {
  const containers = document.querySelectorAll(".card__swatch-wrapper .color-swatch-list");
  if (containers && containers.length > 0) {
    containers.forEach((container) => {
      const swatches = container.querySelectorAll(".color-swatch-item");
      const moreLink = container.querySelector(".swatch-more-link");
      const counterEl = moreLink.querySelector(".swatch-rest-count");
      const containerWidth = container.offsetWidth;

      let visibleWidth = 0;
      let hiddenCount = 0;
      const moreLinkWidth = 40;

      swatches.forEach((swatch, index) => {
        swatch.classList.remove("is-hidden");
        visibleWidth += swatch.offsetWidth + 8;

        if (visibleWidth > containerWidth - moreLinkWidth) {
          swatch.classList.add("is-hidden");
          hiddenCount++;
        }
      });

      if (hiddenCount > 0) {
        moreLink.style.display = "inline-flex";
        counterEl.innerText = `${hiddenCount}`;
      } else {
        moreLink.style.display = "none";
      }
    });
  }
}

// ---- Run updateSwatchesNumber function on load and resize ----
window.addEventListener("resize", updateSwatchesNumber);
window.addEventListener("DOMContentLoaded", updateSwatchesNumber);

// ----  show quick add popup in mobile ----
document.addEventListener("DOMContentLoaded", function () {
  const mobilePopup = document.getElementById("quickAddMobileContainer");
  const popupContent = mobilePopup.querySelector(".quick-add__options");
  const closeBtn = mobilePopup.querySelector(".quick-add__close");

  document.addEventListener("click", function (event) {
    const iconClick = event.target.closest(".quick-add-icon");
    if (!iconClick) return;

    const productCard = iconClick.closest(".product-card-wrapper");
    const sizesHtml = productCard.querySelector(".quick-add-sizes").innerHTML;

    popupContent.innerHTML = sizesHtml;
    mobilePopup.classList.add("is-active");
  });

  //  Close Popup
  const closePopup = () => {
    mobilePopup.classList.remove("is-active");
  };

  closeBtn.addEventListener("click", closePopup);

  // Close if clicking outside the wrapper
  mobilePopup.addEventListener("click", (e) => {
    if (e.target === mobilePopup) closePopup();
  });
});

// --------- close description accordion in mobile device -----------
function manageDescAccordionsByScreen() {
  const accordions = document.querySelectorAll(
    ".product-description-wrapper details",
  );
  if (accordions.length === 0) return;

  const isMobile = window.matchMedia("(max-width: 749px)");

  const updateAccordions = (e) => {
    accordions.forEach((accordion) => {
      if (e.matches) {
        accordion.removeAttribute("open");
      } else {
        accordion.setAttribute("open", "");
      }
    });
  };
  // Initial check on page load
  updateAccordions(isMobile);
  // for screen resize/orientation changes
  isMobile.addEventListener("change", updateAccordions);
}
document.addEventListener("DOMContentLoaded", manageDescAccordionsByScreen);

//Menu Drawer tabs
document.addEventListener("DOMContentLoaded", function () {
  // Tab switching
  document.querySelectorAll(".alo-tab").forEach(function (tab) {
    tab.addEventListener("click", function (e) {
      e.stopPropagation();
      const idx = this.dataset.index;
      document.querySelectorAll(".alo-tab").forEach((t) => {
        t.classList.remove("alo-tab--active");
        t.setAttribute("aria-selected", "false");
      });
      document
        .querySelectorAll(".alo-panel")
        .forEach((p) => p.classList.remove("alo-panel--active"));
      // Close any open grandpanels when switching tabs
      document
        .querySelectorAll(".alo-grandpanel--active")
        .forEach((p) => p.classList.remove("alo-grandpanel--active"));
      this.classList.add("alo-tab--active");
      this.setAttribute("aria-selected", "true");
      document
        .querySelector(`.alo-panel[data-index="${idx}"]`)
        .classList.add("alo-panel--active");
    });
  });

  // Open grandchild panel
  document
    .querySelectorAll(".alo-submenu__item--has-children")
    .forEach(function (item) {
      item.addEventListener("click", function (e) {
        e.stopPropagation();
        const panelId = this.dataset.openPanel;
        const panel = document.getElementById(panelId);
        panel.classList.add("alo-grandpanel--active");
        panel.scrollTop = 0;
        let el = item.parentElement;
        while (el) {
          if (el.scrollTop > 0) el.scrollTop = 0;
          el = el.parentElement;
        }
      });
    });

  // Back button — close grandchild panel
  document.querySelectorAll(".alo-back-btn").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      const panelId = this.dataset.closePanel;
      document
        .getElementById(panelId)
        .classList.remove("alo-grandpanel--active");
    });
  });
});
// Megamenu Hover
document.querySelectorAll(".mega-menu").forEach(function (details) {
  details.addEventListener("mouseenter", function () {
    this.setAttribute("open", "");
  });
  details.addEventListener("mouseleave", function () {
    this.removeAttribute("open");
  });
});


//------------- Horizontal Scrollbar slider -----------
const sliderContainers = document.querySelectorAll('.js-slider-container');
if (sliderContainers && sliderContainers.length > 0) {
  sliderContainers.forEach((slider) => {
    // Find the specific track and thumb belonging ONLY to this slider block
    const wrapper = slider.closest('slider-component');
    const thumb = wrapper.querySelector('.js-scroll-thumb');
    const track = thumb.parentElement;

    let isDragging = false;
    let startX, startScrollLeft;

    // Function to update this specific thumb's width and position
    function updateThumb() {
      const contentWidth = slider.scrollWidth;
      const visibleWidth = slider.clientWidth;
      const trackWidth = track.clientWidth;

      // Skip math if content doesn't overflow (no scrollbar needed)
      if (contentWidth <= visibleWidth) {
        track.style.display = 'none';
        return;
      } else {
        track.style.display = 'block';
      }

      // Dynamic width calculation based on parent widths
      const thumbWidth = (visibleWidth / contentWidth) * trackWidth;
      thumb.style.width = `${Math.max(thumbWidth, 20)}px`; // Min 20px

      const maxScroll = contentWidth - visibleWidth;
      const maxThumbMove = trackWidth - thumb.clientWidth;
      
      const scrollRatio = slider.scrollLeft / maxScroll;
      thumb.style.left = `${scrollRatio * maxThumbMove}px`;
    }

    // Drag Events scoped strictly to this instance
    thumb.addEventListener('mousedown', (e) => {
      isDragging = true;
      startX = e.clientX - thumb.offsetLeft;
      startScrollLeft = slider.scrollLeft;
      document.body.style.userSelect = 'none';
    });

    document.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      
      const maxThumbMove = track.clientWidth - thumb.clientWidth;
      let thumbLeft = e.clientX - startX;
      
      thumbLeft = Math.max(0, Math.min(thumbLeft, maxThumbMove));
      
      const scrollRatio = thumbLeft / maxThumbMove;
      const maxScroll = slider.scrollWidth - slider.clientWidth;
      slider.scrollLeft = scrollRatio * maxScroll;
    });

    document.addEventListener('mouseup', () => {
      isDragging = false;
      document.body.style.userSelect = 'auto';
    });

    // Listeners bound strictly to this individual slider
    slider.addEventListener('scroll', updateThumb);
    window.addEventListener('resize', updateThumb);

    // Initialize this specific slider instance
    updateThumb();
  });
}